// extracted by mini-css-extract-plugin
module.exports = {"validation":"Validation_validation__1U8HR"};